import { AcquisitionChannelsData } from "~/core/resources/customersApi";
import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { DialButton } from "./DialButton";
import { Box } from "../commons/PortraitSelect.styled";

export const PortraitAcquisitionChannelsSelect = ({
  acquisitionChannels,
}: {
  acquisitionChannels: AcquisitionChannelsData[];
}) => {
  const { acquisitionChannelsIds, setAcquisitionChannelsIds } =
    useSimpleRegistrationContext();

  const onClickSelect = (id: number) => {
    if (acquisitionChannelsIds.indexOf(id) > -1) {
      const update = [...acquisitionChannelsIds];
      update.splice(acquisitionChannelsIds.indexOf(id), 1);
      setAcquisitionChannelsIds(update);
    } else {
      const update = [...acquisitionChannelsIds];
      update.push(id);
      setAcquisitionChannelsIds(update);
    }
  };

  const AcquisitionChannelsButtons = () => {
    const buttons = acquisitionChannels.map(
      (v: { id: number; name: string }) => (
        <DialButton
          key={v.id}
          text={v.name}
          onClick={() => onClickSelect(v.id)}
          selected={acquisitionChannelsIds.indexOf(v.id) > -1}
          disabled={
            acquisitionChannelsIds.indexOf(v.id) === -1 &&
            acquisitionChannelsIds.length === 3
          }
        />
      )
    );
    const divList = [];
    for (let i = 0; i < buttons.length; i += 2) {
      divList.push(
        <Box className="button-row" key={i}>
          {buttons.slice(i, i + 2)}
        </Box>
      );
    }
    return <>{divList}</>;
  };

  return (
    <Box className="container">
      <Box className="content">
        <Box className="title">
          <b>내원경로</b>를 선택하세요 (최대 3개)
        </Box>
        <Box className="buttons-container">
          <AcquisitionChannelsButtons />
        </Box>
      </Box>
    </Box>
  );
};
